"use client";
import { useState, useEffect } from "react";
import { Title, Paragraph, Caption } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import Animate from "@/components/Animate";
import newsletterbg from "@/public/newsletter-bg.png";
import { useSelector } from "react-redux";
import { fetchUserIp, getCookieValue } from "@/app/utils/utility";
import {
  addSubscribtion,
  getSubscribedEmailsList,
} from "@/app/redux/auth-management/auth-management-service";

export default function NewsletterSection({ title, subtitle }) {
  const useStore = useSelector((state) => state.auth);
  const [validEmailStatus, setValidEmailStatus] = useState(true);
  const [allreadyEmailStatus, setAllreadyEmailStatus] = useState(false);
  const isUserLoggedIn = !!useStore?.userLoginDetails?.email.length;
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState({ status: "", message: "" });
  const [subScriberEmailLoading, setSubScriberEmailLoading] = useState("");

  const getEmailsList = async () => {
    const response = await getSubscribedEmailsList({
      email: getCookieValue("loggedEmail"),
    });
    setEmail(getCookieValue("loggedEmail"));
    if (response.status) {
      setAllreadyEmailStatus(true);
    } else {
      setAllreadyEmailStatus(false);
    }
  };

  const handleSubscribe = async () => {
    if (!validEmailStatus) {
      setMessage({ status: "error", message: "Please enter valid email" });
      return;
    }

    if (!email) {
      setMessage({
        status: "error",
        message: "Please enter an email address",
      });
      return;
    }

    setSubScriberEmailLoading(true);
    const responses = await fetchUserIp();

    const response = await addSubscribtion({
      email: email,
      ip_address: responses,
    });

    if (response.status) {
      setMessage({
        status: "success",
        message: response.message || "Email subscribed successfully",
      });
      setSubScriberEmailLoading(false);
    } else {
      setMessage({
        status: "alreadyExist",
        message: "Email already subscribed.",
      });
      setSubScriberEmailLoading(false);
      const timer = setTimeout(() => {
        setMessage({ status: "", message: "" });
        clearTimeout(timer);
      }, 8000);
    }
  };

  useEffect(() => {
    getEmailsList();
  }, []);

  return (
    <div className="w-full bg-system-obsidian">
      <div
        className="max-w-[1440px] mx-auto h-[373px] lg:h-[490px] md:h-[300px]"
        style={{
          backgroundImage: `url(${newsletterbg.src})`,
        }}
      >
        <Animate
          animation="fadeInUp"
          duration={1}
          className="flex items-center justify-center"
        >
          <div className="lg:text-center px-6 lg:px-11">
            <Title
              size="xl"
              className="text-system-disabled text-left md:text-center leading-[120%]"
            >
              Subscribe to our newsletter
            </Title>
            <Paragraph className="text-system-disabled mt-[14px] md:mt-[0px] mb-[32px] text:left lg:text-center md:text-center font-normal">
              Weekly updates on sales, drops and important information.
            </Paragraph>
            <div className="md:flex justify-center items-center flex-col">
              <div className="flex justify-center items-center gap-4 flex-col md:flex-row">
                <Input
                  placeholder="Email"
                  type="email"
                  min="1"
                  value={email}
                  className="!mt-[0] placeholder:text-system-steel text-[16px] text-system-silver lg:w-[343px] md:w-[343px] w-[100%] h-[42px] p-[12px] !border-none ring-1 !ring-system-steel/40 bg-system-graphite focus:!ring-system-silver"
                  onChange={(event) => {
                    setEmail(event.target.value);
                    if (event.target.value == "") {
                      setValidEmailStatus(true);
                    } else {
                      setValidEmailStatus(
                        /^[a-zA-Z0-9_.+\-]+[\x40][a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(
                          event.target.value
                        )
                      );
                    }
                  }}
                  style={{
                    border:
                      validEmailStatus || message?.status == "success"
                        ? ""
                        : "1px solid red",
                  }}
                  readOnly={allreadyEmailStatus || isUserLoggedIn}
                />

                <Button
                  size="xl"
                  type="submit"
                  loading={subScriberEmailLoading}
                  disabled={subScriberEmailLoading}
                  onClick={() => {
                    if (!subScriberEmailLoading) {
                      handleSubscribe();
                    }
                  }}
                  className="w-[100%] md:w-[100px]"
                >
                  Subscribe
                </Button>
              </div>

              {message?.status && (
                <Caption
                  className={`text-center 
                  ${
                    message.status === "error"
                      ? "text-system-error"
                      : message.status === "success"
                      ? "text-system-success"
                      : message.status === "alreadyExist"
                      ? "text-system-crystalWhite"
                      : ""
                  } mt-2`}
                >
                  {message?.message}{" "}
                </Caption>
              )}
            </div>
          </div>
        </Animate>
      </div>
    </div>
  );
}
